import { axios } from '../utils/axios'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import { enc } from 'crypto-js'
import Axios from 'axios'

// 获取 token, 其他请求均依赖于 token
export async function login() {
    const timestamp = Date.now()
    const key = process.env.REACT_APP_KEY as string
    const secret = process.env.REACT_APP_SECRET as string
    const signature = HmacSHA256(`key=${key}&timestamp=${timestamp}`, secret).toString(
        enc.Hex
    )
    try {
        let res = await axios({
            url: `/api/user/token/key`,
            method: 'post',
            data: {
                key,
                timestamp,
                signature
            },
            // url: `/api/token`,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

// 鉴权
export async function getAuthData(data) {
    let res = await axios({
        method: 'post',
        url: 'https://websdkauth.faceunity.com/api/websdk/auth',
        data: { data },
        authorization: false,
        timeout: 5000,
    });
    if (res.data && res.data.code === 0 && res.data.data) {
        return res.data.data.cdata;
    } else if (res.status == 200 && res.data.code === 120005) {
        return;
    } else if (res.status == 200) {
        throw res.data.message;
    }
}

// (根据形象id)获取形象配置
export async function getAvatarInfo(params: any) {
    try {
        let res = await axios({
            url: `/api/items/v3/avatar/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}
// (根据资源id)获取单个资源配置  =>  对应的批量接口 /items/resource/list
export async function getResourceById(params: any) {
    try {
        let res = await axios({
            url: `/api/items/v3/resource/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}
// (根据项目id和版本)获取项目配置
export async function getProject(params: any) {
    try {
        let res = await axios({
            url: `/api/items/project/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}
// 公私域拆分
export async function getProjectV3(params: any) {
    try {
        let res = await axios({
            url: `/api/items/v3/app/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}
// 获取资源快照
export async function getItemsSnapshot(itemListUrl) {
    try {
        let res = await Axios.get(itemListUrl)
        console.log('res', res)
        if (res.status == 200) {
            return res.data
        } else {
            throw res
        }
    } catch (err) { }
}

// 获取自定义资源快照
export async function getCentreConfigV3(params: any) {
    try {
        let res = await axios({
            url: `/api/items/v3/app/centre-config`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

// 获取问题集
export async function getTalkSkills(params: any) {
    try {
        let res = await axios({
            url: `/api/demo/config/skill`,
            params,
            authorization: true,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

// 获取demo技能列表
export async function getDemoSkills(params: any) {
    try {
        let res = await axios({
            url: `/api/demo/config/skill`,
            params,
            authorization: true,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

//
export async function getVoiceList(params: any) {
    try {
        let res = await axios({
            url: `/api/demo/config/voicelist`,
            params,
            authorization: true,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

// 存储虚拟人物信息
export async function saveAvatarInfo(params: any, data: any) {
    try {
        let res = await axios({
            method: 'post',
            url: `/api/items/v3/avatar/create`,
            params,
            data,
            headers: { 'Content-Type': 'multipart/form-data' },
            authorization: true,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

export async function generateAvatar(image: any, gender: any) {
    const fd = new FormData()
    fd.append('image', image)
    fd.append('version', '2022-03-01')
    if ([0, 1, -1].includes(gender)) {
        fd.append('gender', gender)
    }
    try {
        let res = await axios({
            method: 'post',
            url: `/api/v1/pta/upload`,
            data: fd,
            headers: { 'Content-Type': 'multipart/form-data' },
            authorization: true,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) { }
}

export async function downloadAvatarById(params: any) {
    let res = await axios({
        method: 'post',
        url: `/api/v1/pta/download`,
        params,
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else if (res.status == 200 && res.data.code === 120005) {
        return
    } else if (res.status == 200) {
        throw res.data.message
    }
}

// 动作列表接口
export async function getAnimationList(params: any) {
    let res = await axios({
        url: `/api/demo/config/animation`,
        params,
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else {
        throw res
    }
}

// 获取资源 arraybuffer
export const fetchArrayBufferByUrl = async function (url: string) {
    const res = await Axios.get(url, { responseType: 'arraybuffer' })
    return res.data
}

// 获取资源文本
export const fetchTextByUrl = function (url: string) {
    return Axios.get(url, { responseType: 'text' })
}

// 云渲染模板列表
export enum CloudRenderTemplateStatus {
    /** 未发布 */
    unpublished = 0,
    /** 已发布 */
    published = 1,
    /** 未保存 */
    not_saved = 2,
}
export enum CloudRenderTemplateType {
    video = 'video',
    gif = 'gif',
    image = 'image',
}
export enum VisibilityType {
    /** 公开 */
    public = 0,
    /** 私有 */
    private = 1
}
export async function getTemplateList(
    params: {
        outputType: CloudRenderTemplateType,
        visibility: VisibilityType,
        status: CloudRenderTemplateStatus,
        page: number,
        limit: number,
        detail: boolean
    }
) {
    let res = await axios({
        method: 'get',
        url: '/api/console/cloud-render-template',
        params,
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else if (res.status == 200 && res.data.code === 120005) {
        return
    } else if (res.status == 200) {
        throw res.data.message
    }
}
export async function getTemplateConfig(
    url
) {
    let res = await axios({
        method: 'get',
        url: '/api/' + url,
        params: {},
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else if (res.status == 200 && res.data.code === 120005) {
        return
    } else if (res.status == 200) {
        throw res.data.message
    }
}
// 资产列表
export enum AssetType {
    background = 'background',
    foreground = 'foreground',
    /** 普通图片 */
    pictures = 'pictures',
    /** 普通视频 */
    videos = 'videos',
    music = 'music',
    avatar = 'avatar',
    voice = 'voice',
}
export async function getAssets(
    params: {
        assetType: AssetType,
        visibility: VisibilityType,
        page: number,
        limit: number
    }
) {
    let res = await axios({
        method: 'get',
        url: 'api/console/asset',
        params,
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else if (res.status == 200 && res.data.code === 120005) {
        return
    } else if (res.status == 200) {
        throw res.data.message
    }
}

// 媒体资源合成
export async function makeMedia(data: any, type: 'video' | 'image' | 'gif') {
    let url = ''
    switch (type) {
        case 'video':
            url += `/api/pta/v3/pta/video/upload`
            break
        case 'image':
            url += '/api/pta/v3/pta/image/upload'
            break
        case 'gif':
            url += '/api/pta/v3/pta/gif/upload'
            break

    }
    let res = await axios({
        method: 'post',
        url,
        data,
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else if (res.status == 200 && res.data.code === 120005) {
        return
    } else if (res.status == 200) {
        throw res.data.message
    }
}

// 轮询视频制作状态
export async function getTaskInfo(data: any, type: 'video' | 'image' | 'gif') {
    let url = ''
    switch (type) {
        case 'video':
            url += `/api/pta/v3/pta/video/download`
            break
        case 'image':
            url += '/api/pta/v3/pta/image/download'
            break
        case 'gif':
            url += '/api/pta/v3/pta/gif/download'
            break

    }
    let res = await axios({
        method: 'post',
        url,
        data,
        authorization: true,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data
    } else if (res.status == 200) {
        return res.data
    } else {
        throw res.data.message
    }
}